import type { IconConfig } from '../types'
import { Panel } from './Panel'

interface Props {
  value: IconConfig['corners']
  onChange: (corners: IconConfig['corners']) => void
}

type CornerKey = 'tl' | 'tr' | 'bl' | 'br'

const CORNERS: { key: CornerKey; symbol: string; title: string }[] = [
  { key: 'tl', symbol: '◜', title: 'Top-left' },
  { key: 'tr', symbol: '◝', title: 'Top-right' },
  { key: 'bl', symbol: '◟', title: 'Bottom-left' },
  { key: 'br', symbol: '◞', title: 'Bottom-right' },
]

export function CornerPicker({ value, onChange }: Props) {
  const toggle = (key: CornerKey) => {
    onChange({ ...value, [key]: !value[key] })
  }

  const roundedCount = CORNERS.filter((corner) => value[corner.key]).length

  return (
    <Panel title="Shape" description="Round or sharpen each corner. All 16 Sailfish base shapes are covered.">
      <div class="corner-grid">
        {CORNERS.map(({ key, symbol, title }) => (
          <button
            key={key}
            type="button"
            class={`corner-btn${value[key] ? ' active' : ''}`}
            onClick={() => toggle(key)}
            title={title}
            aria-pressed={value[key]}
          >
            {value[key] ? symbol : '▢'}
          </button>
        ))}
      </div>
      <p class="panel-desc" style="margin:0">
        {roundedCount}/4 corners rounded
      </p>
    </Panel>
  )
}
